// @flow

import React, { Fragment } from 'react'
import {
	Field,
	reduxForm,
  change
} from 'redux-form'

import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import SupportListNew from '../partials/SupportListNew.jsx'
import BannerDemoNew from '../partials/BannerDemoNew.jsx'
import imgFirstAsia from '../../images/public/FirstAsiaConsultants.png'
import imgKarirpad from '../../images/public/Karirpad.png'
import imgUrbanHire from '../../images/public/Urbanhire.png'
import imgIndotrainee from '../../images/public/Indotrainee.png'
import imgHCC from '../../images/public/hcc.png'
import imgPulsifi from '../../images/public/pulsifi.png'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import imgPartnership from '../../images/partnership-banner.png'
import imgCard1 from '../../images/img_intgration_partner_01.png'
import imgCard2 from '../../images/img_intgration_partner_02.png'
import imgCard3 from '../../images/img_intgration_partner_03.png'
import imgSeamless from '../../images/seamless.png'

import PartnershipForm from './PartnershipForm'


import {getOSInfo , translate } from '../../helpers/global'

type State = {
	jobs: Array<Object>
};

class PartnersPageNew extends React.Component<State> {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {
    const{globalGetLanguages} = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
	        <HeaderNewClear isOnStatusFor="is-on" />
	        <div className="banner home partner page">
	
				<section>
					<div className="ban-text partnership-ban">
						<div className="big-text">Building the Talent Ecosystem Together</div>
						<p className="partnership-desc">Great talent decisions are not made in isolation. That is why ASTRNT partners with leading platforms and<br/>communities to make hiring, assessment and development seamless.<br/>Our ecosystem is designed to connect with the tools you already use, while opening new opportunities to collaborate and innovate.</p>
					</div>
				</section>
			</div>
		<div className="sec-white relative">
          <section className="sec-con partnership-section">
            <ul>
              <li>
                <ul className="on-left card-partner">
                  <li>
                  Technology That Connects
                    <span>ASTRNT integrates with platforms that companies trust for hiring and workflow management. From established solutions like <strong>Greenhouse, Workable, and many more</strong>, our technology ensures assessments and interviews fit naturally into your process. Integration means less disruption, faster adoption, and better outcomes for your team.</span>
                  </li>
                  <li>
                    <img className="img-card-left" src={imgCard1} />
                  </li>
                </ul>
              </li>
            </ul>
          </section>
          <span className="blue-curve-top-right-flip"></span>
        </div>
		<div className="sec-white">
          <section className="sec-con partnership-section">
            <ul>
              <li>
                <ul className="on-right card-partner">
                  <li>
                  Powered by ASTRNT
                    <span>Our capabilities are not limited to our own platform. Every assessment, interview, and scoring method can be delivered through APIs. That is why organisations like <strong>Popskul Jobs</strong> and <strong>Pulsifi</strong> are building their own career platforms with ASTRNT running behind the scenes. The result: partners bring their vision to life, while we provide the validated technology that makes it work.</span>
                  </li>
                  <li>
                    <img className="img-card-right" src={imgCard2} />
                  </li>
                </ul>
              </li>
            </ul>
          </section>
        </div>
		<div className="sec-white relative">
          <section className="sec-con partnership-section">
            <ul>
              <li>
                <ul className="on-left card-partner last-card">
                  <li>
                  Communities that Shape the Future
                    <span>We believe partnerships also thrive through knowledge sharing. With collaborations with HR communities and initiatives like <strong>Talent Buzz</strong> in Indonesia, ASTRNT creates spaces where professionals exchange ideas, learn from each other, and shape the future of the talent profession. These activities are as important as technology integrations, because strong communities drive stronger outcomes.</span>
                  </li>
                  <li>
                    <img className="img-card-left" src={imgCard3} />
                  </li>
                </ul>
              </li>
            </ul>
          </section>
          <span class="blue-curve-bottom-left"></span>
        </div>
        <div className="section-white bg-gray center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right'>
            <div className='gray-small-triangle-bottom-right'></div>
          </div>
          <div style={{width: '830px', maxWidth: '90%'}}>
            <h1 className='title-1'>
              Always Open for Collaboration
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              Our current partners are only the beginning. We are constantly looking for organisations that share our vision to make hiring more efficient, inclusive, and data-driven. Whether you are building an ATS, jobs board, HRIS, or a new idea altogether, there is room to collaborate with ASTRNT.
            </p>
            <p>Let’s explore how we can build together.</p>
            <div>
              <a className='btn btn-primary-red' onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')}>
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
	        <FooterNew />
	      </div>
		)
  }
}

const mapStateToProps = (state) => {
  return{ 
    globalGetLanguages:state.globalGetLanguages,
  }
  
}

export default connect(mapStateToProps, null )(PartnersPageNew)
